import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { IPostLoginBody, IPostRefreshToken } from 'src/app/interfaces';
import { IToken } from 'src/app/interfaces/token/IToken';
import { LoginService } from '../login/login.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private _authNavStatusSource = new BehaviorSubject<boolean>(false);
  authNavStatus$ = this._authNavStatusSource.asObservable();
  helper = new JwtHelperService();
  constructor(private loginService: LoginService, private router: Router) {
    const token = this.obterRawToken();

    if (token && token.length > 0) {
      this._authNavStatusSource.next(true);
      return;
    }
  }
  loginUsuario(data: IPostLoginBody) {
    return this.loginService.postLogin(data).pipe(
      tap({
        next: ({ data: { token, refreshToken } }) => {
          this._authNavStatusSource.next(true);
          this.registrarTokens(token, refreshToken);
        },
        error: () => {
          this._authNavStatusSource.next(false);
        }
      })
    );
  }
  reautenticarUsuario(data: IPostRefreshToken) {
    return this.loginService.postRefreshToken(data).pipe(
      tap({
        next: ({ data: { token, refreshToken } }) => {
          this._authNavStatusSource.next(true);
          this.registrarTokens(token, refreshToken);
        },
        error: () => {
          this._authNavStatusSource.next(false);
        }
      })
    );
  }
  private registrarTokens(token: string, refreshToken: string) {
    const decoded = this.helper.decodeToken(token);
    const aux: IToken = {
      ...decoded,
      id: Number(decoded.id),
      perfilId: Number(decoded.perfilId),
      autorizacoes: JSON.parse(decoded.autorizacoes),
      codContrato: JSON.parse(decoded.codContrato),
      refreshToken
    };
    sessionStorage.setItem('rawToken', token);
    sessionStorage.setItem('token', JSON.stringify(aux));
  }
  obterToken(): IToken {
    const tokenString = sessionStorage.getItem('token')!;
    return JSON.parse(tokenString) as IToken;
  }
  obterRawToken(): string {
    return sessionStorage.getItem('rawToken')!;
  }
  logoutUsuario() {
    this._authNavStatusSource.next(false);
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }
}
